<div
    *ngIf="visible"
    class="cdb"
    [class.cdb--pre]="variant === 'pre'"
    [class.cdb--today]="variant === 'today'"
    [class.cdb--overdue]="variant === 'overdue'"
    [class.cdb--blocked]="variant === 'blocked'"
    [class.cdb--dismissible]="dismissible"
>
    <fina-banner-close *ngIf="dismissible" (dismiss)="hide()"></fina-banner-close>
    <span class="cdb__icon" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
            <line x1="12" y1="8" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12" y2="17.01" />
        </svg>
    </span>

    <div class="cdb__msg">
        <ng-container *ngIf="variant === 'pre'">
            Faltan <strong>{{ diasFaltantes }} {{ diasFaltantes === 1 ? 'día' : 'días' }}</strong>
            para que se venza tu cuota del préstamo. Para evitar el bloqueo de acceso a Fina y tener la oportunidad de montos mayores en el futuro, paga a tiempo.
        </ng-container>

        <ng-container *ngIf="variant === 'today'">
            Tu cuota del préstamo <strong>vence hoy</strong>. Para evitar el bloqueo de acceso a Fina y tener la oportunidad de montos mayores en el futuro, paga a tiempo.
        </ng-container>

        <!-- El fee muestra al lado su equivalente en Bs. a la tasa BCV del día (oculto si la tasa no cargó). -->
        <ng-container *ngIf="variant === 'overdue' && !esUltimoDiaGracia">
            Tu cuota del préstamo venció hace <strong>{{ diasVencidos }} {{ diasVencidos === 1 ? 'día' : 'días' }}</strong
            >. En <strong>{{ diasParaBloqueo }} {{ diasParaBloqueo === 1 ? 'día' : 'días' }}</strong> tu acceso a Fina va a ser bloqueado y tendrás que pagar un fee de reactivación de
            <strong>${{ activationFee }}</strong
            ><ng-container *ngIf="vesRate$ | async as tasa"> (Bs. {{ activationFee * tasa | number : '1.2-2' }})</ng-container>.
        </ng-container>

        <ng-container *ngIf="variant === 'overdue' && esUltimoDiaGracia">
            Tu cuota del préstamo venció hace <strong>{{ diasVencidos }} días</strong>. <strong>Mañana</strong> tu acceso a Fina va a ser bloqueado y tendrás que pagar un fee de reactivación de
            <strong>${{ activationFee }}</strong
            ><ng-container *ngIf="vesRate$ | async as tasa"> (Bs. {{ activationFee * tasa | number : '1.2-2' }})</ng-container>.
        </ng-container>

        <ng-container *ngIf="variant === 'blocked' && !pendingVerification">
            Tu acceso a Fina ha sido <strong>bloqueado</strong> por falta de pago de tu préstamo. Para retomar acceso debes pagar lo que falta de tu cuota + fee de reactivación (<strong
                >${{ activationFee }}</strong
            ><ng-container *ngIf="vesRate$ | async as tasa"> — Bs. {{ activationFee * tasa | number : '1.2-2' }}</ng-container
            >)<ng-container *ngIf="totalToUnblock"
                >: <strong>${{ totalToUnblock | number : '1.2-2' }}</strong> en total</ng-container
            >.
        </ng-container>

        <ng-container *ngIf="variant === 'blocked' && pendingVerification">
            Tu acceso a Fina sigue <strong>bloqueado</strong> mientras verificamos el pago de tu cuota vencida. Se reactiva apenas el equipo de Fina lo confirme.
        </ng-container>
    </div>
</div>
